import { useState, useEffect } from "react";
import Icon, {
    BranchesOutlined,
    CalendarFilled,
    CameraFilled,
    TableOutlined,
} from "@ant-design/icons";
import { Col, Menu, Drawer, Button, Space } from "antd";
import { Link } from "react-router-dom";
import "./index.scss";
const { SubMenu } = Menu;
const MenuContainer = ({ toggleMenu }) => {
    // Lấy openKeys từ localStorage nếu có, nếu không thì []
    const [openKeys, setOpenKeys] = useState(() => {
        const saved = localStorage.getItem("menuOpenKeys");
        return saved ? JSON.parse(saved) : [];
    });

    // Lưu openKeys vào localStorage mỗi khi thay đổi
    useEffect(() => {
        localStorage.setItem("menuOpenKeys", JSON.stringify(openKeys));
    }, [openKeys]);

    const onOpenChange = (keys) => {
        setOpenKeys(keys);
    };

    return (
        <Menu
            gutter={6}
            mode="inline"
            inlineCollapsed={toggleMenu}
            style={{
                minHeight: "1011px",
                borderRadius: 20,
                textAlign: "left",
            }}
            openKeys={openKeys}
            onOpenChange={onOpenChange}
        >
            {/* <Menu.Item
                key="dashboard"
                style={{
                    backgroundColor: "rgb(128 126 128 / 10%)",
                    marginTop: 30,
                    fontSize: "bold",
                }}
            >
                <Link
                    to="/dashboard"
                    style={{ fontWeight: "bold" }}
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/doard.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>Doardborad</span>
                </Link>
            </Menu.Item> */}
            <Menu.Item
                key="content"
                style={{
                    backgroundColor: "rgb(128 126 128 / 10%)",
                    fontSize: "bold",
                    marginTop: 30,
                }}
            >
                <Icon
                    component={() => (
                        <img
                            src="/icon/content.svg"
                            className="menu-img"
                        />
                    )}
                />
                <span style={{ fontWeight: "bold" }}>Content</span>
            </Menu.Item>
            <Menu.Item
                key="home"
            >
                <Link
                    to="/block/list/"
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/home.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>Home</span>
                </Link>
            </Menu.Item>
            <SubMenu
                key="Về chúng tôi"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/about.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Về chúng tôi
                        </span>
                    </span>
                }
            >
                <Menu.Item key="thongdiep">
                    <Link to="/investor/thong-diep">
                        <TableOutlined />
                        <span>Thông điệp</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="khuonvien">
                    <Link to="/investor/banner">
                         <TableOutlined />
                        <span>Khuôn viên</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="doingu">
                    <Link to="/investor/doi-ngu">
                        <TableOutlined />
                        <span>Đội ngũ</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            
            <SubMenu
                key="Khối"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/block.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Cấp học
                        </span>
                    </span>
                }
            >
                <Menu.Item key="kmn">
                    <Link to="/about/edit/1">
                        <TableOutlined />
                        <span>Khối Mầm Non</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="kth">
                    <Link to="/about/edit/2">
                        <TableOutlined />
                        <span>Khối Tiểu học</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="kthcs">
                    <Link to="/about/edit/3">
                        <TableOutlined />
                        <span>Khối THCS</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="kthpt">
                    <Link to="/about/edit/4">
                        <TableOutlined />
                        <span>Khối THPT</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="duan">
                    <Link to="/about/project/list">
                        <TableOutlined />
                        <span>Dự án</span>
                    </Link>
                </Menu.Item>
            </SubMenu>

            {/* <Menu.Item
                key="invester"
            >
                <Link
                    to="/investor/edit/1"
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/invester.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>Investor</span>
                </Link>
            </Menu.Item> */}

            {/* <Menu.Item
                key="Abouta"
            >
                <Link
                    to="/about/edit/1"
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/about.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>About</span>
                </Link>
            </Menu.Item> */}
            <SubMenu
                key="why-chooseasda"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/why.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Đời sống học sinh
                        </span>
                    </span>
                }
            >
                <Menu.Item key="tamly">
                    <Link to="/why-choose/tam-ly/5">
                        <TableOutlined />
                        <span>Tâm lý</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="chamsoc">
                    <Link to="/why-choose/cham-soc/6">
                        <TableOutlined />
                        <span>Chăm sóc</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="nangkhieunang">
                    <Link to="/why-choose/nang-khieu">
                        <TableOutlined />
                        <span>Năng khiếu</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            <SubMenu
                key="quangtri-main"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/contact.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Tuyển sinh
                        </span>
                    </span>
                }
            >
                <Menu.Item key="quangtri-main-a">
                    <Link to="/tuyen-sinh/action/7">
                        <TableOutlined />
                        <span>Chi tiết</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="quangtri-main-b">
                    <Link to="/tuyen-sinh/chuong-trinh">
                        <TableOutlined />
                        <span>Chương trình</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="hoi-dap">
                    <Link to="/tuyen-sinh/hoi-dap">
                        <TableOutlined />
                        <span>Hỏi đáp</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            {/* <Menu.Item
                key="Aboutaaa"
            >
                <Link
                    to="/why-choose/edit/1"
                >
                    <Icon
                        component={() => (
                            <img
                                src="/icon/why.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    <span>Why choose</span>
                </Link>
            </Menu.Item> */}
            <SubMenu
                key="tuyen-dung"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/partner.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Tuyển dụng
                        </span>
                    </span>
                }
            >
                <Menu.Item key="job-add">
                    <Link to="/tuyen-dung/add">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="list-job">
                    <Link to="/tuyen-dung/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List Job</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="list-apply">
                    <Link to="/tuyen-dung/list-apply">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List Apply</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            <SubMenu
                key="news"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/news.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>News</span>
                    </span>
                }
            >
                <Menu.Item key="scheduledMailListdas">
                    <Link to="/news/add">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="scheduledMailListdassda">
                    <Link to="/news/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu>
            <Menu.Item
                key="contact"
            // style={{
            //     backgroundColor: "rgb(128 126 128 / 10%)",
            //     marginTop: 30,
            //     fontSize: "bold",
            // }}
            >
                <Link
                    to="/contact/list"
                >
                    {/* <DashboardOutlined style={{ fontWeight: "bold" }} /> */}
                    <Icon
                        component={() => (
                            <img
                                src="/icon/newsletter.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    {/* <img src="/icon/doard.svg" className='menu-img'/> */}
                    <span>Đăng ký tư vấn</span>
                </Link>
            </Menu.Item>
            {/* <SubMenu
                key="media"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/media.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>Media</span>
                    </span>
                }
            >
                <Menu.Item key="scheduledMailListaaa">
                    <Link to="/media/add">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="scheduledMailListasd">
                    <Link to="/media/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            <Menu.Item
                key="media"
            // style={{
            //     backgroundColor: "rgb(128 126 128 / 10%)",
            //     marginTop: 30,
            //     fontSize: "bold",
            // }}
            >
                <Link
                    to="/media/list"
                >
                    {/* <DashboardOutlined style={{ fontWeight: "bold" }} /> */}
                    <Icon
                        component={() => (
                            <img
                                src="/icon/media.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    {/* <img src="/icon/doard.svg" className='menu-img'/> */}
                    <span>Media</span>
                </Link>
            </Menu.Item>
            {/* <SubMenu
                        key="word"
                        title={
                            <span>
                                <CalendarFilled />
                                <span style={{ marginTop: 10 }}>Work</span>
                            </span>
                        }
                    >
                        <Menu.Item key="wordadd">
                            <Link to="/work/add">
                                <TableOutlined />
                                <span>Add</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="wordlist">
                            <Link to="/work/list">
                                <TableOutlined />
                                <span>List</span>
                            </Link>
                        </Menu.Item>
                    </SubMenu> */}

            {/* <SubMenu
                key="contact"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/contact.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Contact
                        </span>
                    </span>
                }
            >
                <Menu.Item key="contactad">
                    <Link to="/contact/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}

            {/* <SubMenu
                key="brand"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/partner.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>Partners</span>
                    </span>
                }
            >
                <Menu.Item key="branda">
                    <Link to="/brand/add">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="brandb">
                    <Link to="/brand/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            <Menu.Item
                key="WorkShop"
                style={{
                    backgroundColor: "rgb(128 126 128 / 10%)",
                    fontSize: "bold",
                }}
            >
                <Icon
                    component={() => (
                        <img
                            src="/icon/workshop.svg"
                            className="menu-img"
                        />
                    )}
                />
                <span style={{ fontWeight: "bold" }}>WorkShop</span>
            </Menu.Item>
            {/* <SubMenu
                key="setting"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/setting.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Setting
                        </span>
                    </span>
                }
            >
                <Menu.Item key="settinga">
                    <Link to="/setting/detail">
                        <TableOutlined />
                        <span>Detail</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            <Menu.Item
                key="setting"
            // style={{
            //     backgroundColor: "rgb(128 126 128 / 10%)",
            //     marginTop: 30,
            //     fontSize: "bold",
            // }}
            >
                <Link
                    to="/setting/detail"
                >
                    {/* <DashboardOutlined style={{ fontWeight: "bold" }} /> */}
                    <Icon
                        component={() => (
                            <img
                                src="/icon/setting.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    {/* <img src="/icon/doard.svg" className='menu-img'/> */}
                    <span>Setting</span>
                </Link>
            </Menu.Item>

            <Menu.Item
                key="myAccount"
                style={{
                    backgroundColor: "rgb(128 126 128 / 10%)",
                    fontSize: "bold",
                }}
            >
                <Icon
                    component={() => (
                        <img
                            src="/icon/account.svg"
                            className="menu-img"
                        />
                    )}
                />
                <span style={{ fontWeight: "bold" }}>
                    My account
                </span>
            </Menu.Item>
            {/* <SubMenu
                key="myAccountaas"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/user2.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>User</span>
                    </span>
                }
            >
                <Menu.Item key="myAccountav">
                    <Link to="/user/list">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
            <Menu.Item
                key="translatdsdfse"
            // style={{
            //     backgroundColor: "rgb(128 126 128 / 10%)",
            //     marginTop: 30,
            //     fontSize: "bold",
            // }}
            >
                <Link
                    // :to="{`/profile/edit/${localStorage.getItem('id')}`}"
                    to={`/profile/edit/${localStorage.getItem('id')}`}
                >
                    {/* <DashboardOutlined style={{ fontWeight: "bold" }} /> */}
                    <Icon
                        component={() => (
                            <img
                                src="/icon/user2.svg"
                                className="menu-img"
                            />
                        )}
                    />
                    {/* <img src="/icon/doard.svg" className='menu-img'/> */}
                    <span>Profile</span>
                </Link>
            </Menu.Item>
            {/* <SubMenu
                key="Apikey"
                title={
                    <span>
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/api.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span style={{ marginTop: 10 }}>
                            Api key
                        </span>
                    </span>
                }
            >
                <Menu.Item key="Apikey1">
                    <Link to="/#">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/add.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>Add</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="Apikey2">
                    <Link to="/#">
                        <Icon
                            component={() => (
                                <img
                                    src="/icon/list.svg"
                                    className="menu-img"
                                />
                            )}
                        />
                        <span>List</span>
                    </Link>
                </Menu.Item>
            </SubMenu> */}
        </Menu>
    );
};

export default MenuContainer;
